import type { ButtonPushLocale } from "@/locales/fr/button-push";

const buttonPushLocale: ButtonPushLocale = {
  buttonPush: {
    buttonPush: "Button Push",
    lastPushButton: "Last Push",
    pushButtonCount: "Push count last {n} hours",
  },
};

export default buttonPushLocale;
